<div class="grid grid-cols-3 gap-1">
  <soft-date-input
    [value]="date()"
    (valueChange)="setDate($event)"
    [readonly]="readonly()"
    class="col-span-2"
    (blur)="onTouch()"
  ></soft-date-input>
  <soft-time-input
    [value]="time()"
    (valueChange)="setTime($event)"
    [readonly]="readonly()"
    (blur)="onTouch()"
  ></soft-time-input>
</div>
